import React from 'react';
import styled from 'styled-components';
import { Theme, StopCard, StopCardRow, Skeleton } from '@routific/hive';
import { DUMMY_LOADING_ARRAY } from '../../../../../constants';

const { Colors, Spacing, BorderRadius } = Theme;

const CardPadding = styled.div`
  padding: ${Spacing.smSpacing} ${Spacing.mdSpacing};
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.smSpacing};
  flex: 1;
  min-width: 0;
`;

const TimelineSkeleton = styled(Skeleton)`
  flex: 1;
  min-width: 0;
  .ant-skeleton-content {
    margin: 0;
    padding-left: 0;
  }
  .ant-skeleton-title {
    margin: 0;
  }
  .ant-skeleton-paragraph {
    display: none;
  }
`;

const SkeletonDot = styled.div<{ $size?: string }>`
  width: ${({ $size }) => $size ?? '24px'};
  height: ${({ $size }) => $size ?? '24px'};
  border-radius: 50%;
  background-color: ${Colors.gray2};
  flex-shrink: 0;
`;

const HEADER_DOT_SIZE = '24px';
const ROW_DOT_SIZE = '16px';
const ROW_ORDER_NUMBER_WIDTH = '64px';
/** Offset so row content bars align with header bar (header uses 24px dot, row uses 16px) */
const ROW_CONTENT_ALIGN_OFFSET = '8px';

const RowContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.smSpacing};
  width: 100%;
  min-width: 0;
`;

const RowContentSkeletonWrap = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: ${ROW_CONTENT_ALIGN_OFFSET};
`;

const OrderNumberSkeleton = styled.div`
  width: ${ROW_ORDER_NUMBER_WIDTH};
  height: 12px;
  border-radius: ${BorderRadius.mdBorderRadius};
  background-color: ${Colors.gray2};
  flex-shrink: 0;
`;

// Vary row counts per card so it looks like real route data
const ROW_COUNTS = [1, 2, 1, 1, 2, 1, 3, 1, 2, 1];

const SkeletonTimeline: React.FC = () => (
  <>
    {DUMMY_LOADING_ARRAY.map((i) => (
      <CardPadding key={i}>
        <StopCard
          marker={<SkeletonDot $size={HEADER_DOT_SIZE} />}
          header={
            <HeaderContent>
              <TimelineSkeleton active paragraph={false} title={{ width: '75%' }} />
            </HeaderContent>
          }
        >
          {Array.from({ length: ROW_COUNTS[i % ROW_COUNTS.length] ?? 1 }).map((_, j) => (
            // eslint-disable-next-line react/no-array-index-key
            <StopCardRow key={j}>
              <RowContent>
                <SkeletonDot $size={ROW_DOT_SIZE} />
                <RowContentSkeletonWrap>
                  <TimelineSkeleton active paragraph={false} title={{ width: '60%' }} />
                </RowContentSkeletonWrap>
                <OrderNumberSkeleton />
              </RowContent>
            </StopCardRow>
          ))}
        </StopCard>
      </CardPadding>
    ))}
  </>
);

export default SkeletonTimeline;
